/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportSettingsResponse } from '../../models/export-settings-response';

export interface ExportSettings$Params {
}

export function exportSettings(http: HttpClient, rootUrl: string, params?: ExportSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportSettingsResponse>> {
  const rb = new RequestBuilder(rootUrl, exportSettings.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportSettingsResponse>;
    })
  );
}

exportSettings.PATH = '/api/v1/Settings/ExportSettings';
